import { useContext, Ref } from "react";
import { StepProps, Steps } from "antd";
import { FieldErrors } from "react-hook-form";
import {
    IdcardOutlined,
    SettingOutlined,
    FolderOpenOutlined,
    BgColorsOutlined,
} from "@ant-design/icons";

import { ICityInputs } from "../../interfaces";
import { ThemeContext } from "../../../../contexts/ThemeContext";

interface IItem extends StepProps {
    fields: Array<keyof ICityInputs>;
}

interface IProps {
    currentStep: number;
    items: Array<IItem>;
    errors: FieldErrors<ICityInputs>;
    refSteps?: Ref<HTMLDivElement>;
}

const STEP_ICONS = [
    <IdcardOutlined key="icon-register" />,
    <SettingOutlined key="icon-config" />,
    <FolderOpenOutlined key="icon-files" />,
    <BgColorsOutlined key="icon-custom" />,
];

export default function FormStepsController({
    currentStep,
    items,
    errors,
    refSteps,
}: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div
            ref={refSteps}
            style={{
                background: isDark ? "#141414" : "#ffffff",
                borderRadius: 10,
                border: `1px solid ${isDark ? "#262626" : "#eaedf1"}`,
                boxShadow: isDark
                    ? "0 4px 20px rgba(0, 0, 0, 0.35)"
                    : "0 2px 10px rgba(0, 0, 0, 0.03)",
                padding: "16px 24px",
                display: "flex",
                justifyContent: "center",
                width: "100%",
            }}
        >
            <div style={{ width: "100%", maxWidth: 840 }}>
                <Steps
                    current={currentStep}
                    size="small"
                    responsive
                    items={items.map((item, index) => {
                        const hasError = item.fields.some((field) => errors[field]);
                        return {
                            ...item,
                            icon: item.icon || STEP_ICONS[index],
                            status: hasError ? "error" : undefined,
                            style: { cursor: "pointer" },
                        };
                    })}
                />
            </div>
        </div>
    );
}